import { UserFeedbackCodeEnum } from '../../../models/constants'
import { EleCodeEnum } from '@inv/constants'
import { IBlockCoreConfig } from '../../../models/BlockModel/typing'
import { noop } from '@inv/hooks'
import { validateFeedbackDescription } from '../../ValidateFunction/validateFeedbackDescription'
import { validateEmail } from '../../ValidateFunction/validateEmail'
import { isFieldSubmittable } from '../../../models/utils'
import { BlockTypeEnum } from '../../../models/BlockModel/const'

export const BLOCK_ORDER = [BlockTypeEnum.ADD_USER_FEEDBACK]

export const FIELDS_BLOCK_CONFIGS: IBlockCoreConfig<
  BlockTypeEnum,
  EleCodeEnum | UserFeedbackCodeEnum
> = {
  [BlockTypeEnum.ADD_USER_FEEDBACK]: {
    fields: [
      {
        code: UserFeedbackCodeEnum.Type,
        isFieldSubmittable,
        validate: { type: noop }
      },
      {
        code: UserFeedbackCodeEnum.Scenario,
        isFieldSubmittable,
        validate: { type: noop }
      },
      {
        code: UserFeedbackCodeEnum.Description,
        isFieldSubmittable,
        validate: { type: validateFeedbackDescription }
      },
      {
        code: UserFeedbackCodeEnum.Attachment,
        isFieldSubmittable,
        validate: { type: noop }
      },
      {
        code: UserFeedbackCodeEnum.EmailCheckBox,
        isFieldSubmittable,
        validate: { type: noop }
      },
      {
        code: EleCodeEnum.Email,
        isFieldSubmittable,
        validate: { type: validateEmail }
      }
    ]
  }
}
